import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { UPDATE_AD_SETS_BUDGET_BID } from './updateAdSetsBudget.mutation';
import {
  UpdateAdSetsBudgetMutation,
  UpdateAdSetsBudgetMutation_updateAdSetsBudget_adSets,
  UpdateAdSetsBudgetMutationVariables
} from './__generated__/UpdateAdSetsBudgetMutation';

type MutationProps = {
  onStart?: () => void;
  onCompleted: (adSetId: UpdateAdSetsBudgetMutation_updateAdSetsBudget_adSets[]) => void;
  onError?: (errors: string[]) => void;
};

export const useUpdateAdSetsBudget = ({ onStart, onCompleted, onError }: MutationProps) => {
  const [updateAdSetBudget] = useMutation<UpdateAdSetsBudgetMutation, UpdateAdSetsBudgetMutationVariables>(
    UPDATE_AD_SETS_BUDGET_BID,
    {
      client: kmsClient,
      onCompleted: (data) => {
        if (data.updateAdSetsBudget?.errors?.length) {
          if (onError) onError(data.updateAdSetsBudget.errors);
        } else {
          if (onCompleted && data.updateAdSetsBudget?.adSets) onCompleted(data.updateAdSetsBudget.adSets);
        }
      },
      onError: (error) => onError && onError([error.message])
    }
  );
  return (variables: UpdateAdSetsBudgetMutationVariables) => {
    if (onStart) onStart();
    updateAdSetBudget({ variables });
  };
};
